export default __webpack_public_path__ + "static/media/abat.f8b9b762.svg";